import {CrudModel} from '@ngx-ivengi/crud';

export class Profile extends CrudModel {
  public email: string;
  public password: string;
  public passwordConfirmation: string;
  public firstName: string;
  public lastName: string;
  public phoneNr: string;
  public roles: string[];
  public isEmployee: boolean;
  public isOwner: boolean = false;
  public isCustomer: boolean = false;

  public setPassword(password: string): Profile {
    if(typeof password === 'string') {
      this.password = password;
    }
    return this;
  }

  public getPassword(): string {
    return this.password;
  }

  public setFirstName(firstName: string): Profile {
    if(typeof firstName === 'string') {
      this.firstName = firstName;
    }
    return this;
  }

  public getFirstName(): string {
    return this.firstName;
  }

  public setLastName(lastName: string): Profile {
    if(typeof lastName === 'string') {
      this.lastName = lastName;
    }
    return this;
  }

  public getLastName(): string {
    return this.lastName;
  }

  public setPhoneNr(phoneNr: string): Profile {
    if(typeof phoneNr === 'string') {
      this.phoneNr = phoneNr;
    }
    return this;
  }

  public getPhoneNr(): string {
    return this.phoneNr;
  }

  public setEmail(email: string): Profile {
    if(typeof email === 'string') {
      this.email = email;
    }
    return this;
  }

  public getEmail(): string {
    return this.email;
  }

  public getRoles(): string [] {
    return this.roles;
  }

  public setRoles(roles: string[]) {
    if(roles instanceof Array) {
      this.roles = roles.filter((role) => {
        return (typeof role === 'string');
      });

      if(this.roles.includes('OWNER')) {
        this.isOwner = true;
      }

      if (this.roles.includes('CUSTOMER')) {
        this.isCustomer = true;
      }
    }
    return this;
  }

  public setAsEmployee(isEmployee: boolean): Profile {
    if(typeof isEmployee === 'boolean') {
      this.isEmployee = isEmployee;
    }
    return this;
  }

  public fromResponse(response: any): void {
    if(response) {
      this
        .setId(response.id)
        .setFirstName(response.firstName)
        .setLastName(response.lastName)
        .setPhoneNr(response.phoneNr)
        .setEmail(response.email)
        .setRoles(response.roles)
        .setAsEmployee(response.isEmployee);
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/profile/profile.model.ts